module.exports = __webpack_public_path__ + "images/icons/icon-shipping-box-5a8e1cbb.svg";